export const comparatorPayloadGeneration = ({
  providerWorkflow,
  contractId,
  contactId,
  country,
  address,
  energyType,
  prestationType,
  clientType,
  consumption,
  meterPower,
}) => ({
  workflowName: providerWorkflow || 'default',
  contract_id: contractId,
  contact_id: contactId || null,
  country,
  city_id: address.cityId || '',
  city: address.city || '',
  zipcode: address.zipcode || '',
  province: address.province || '',
  street_name: address.streetName || '',
  energy_type: energyType || '',
  client_type: clientType === 'pro' ? 'business' : 'domestic',
  prestation_type: prestationType || 'cdf',
  is_resident: address.isResident ? 1 : 0,
  meter_power_elec: meterPower || '',
  italy_consumption_base: consumption.carElec,
  car_gas: consumption.carGas,
  comparator_mode: true,
})
